/*
 * format (utils)
 */
export function appendPrefixIfMissing(message: string, prefix: string) {
	if (message.split(prefix).length === 1) {
		return prefix + message
	}
	return message
}

export function capitalizeFirstLetter(
	message: string,
	allWords = false,
	splitChar = " ",
	joinChar = " ",
): string {
	if (allWords) {
		return message
			?.split(splitChar)
			.map((value: string) => capitalizeFirstLetter(value))
			.join(joinChar)
	}
	return message.charAt(0).toUpperCase() + message.slice(1)
}

export function sentenceCase(message: string): string {
	return message.charAt(0).toUpperCase() + message.slice(1).toLowerCase()
}

export function lowerCase(message: string): string {
	return message.toLowerCase()
}

export function hidePartialSecretValue(
	value: string,
	viewableChars = 4,
	maxChars = 10,
): string {
	let endStar = value.length - viewableChars - 1
	if (endStar < 0) {
		endStar = 0
	}

	for (let index = 0; index < value.length; index++) {
		if (index <= endStar) {
			value = value.substring(0, index) + "*" + value.substring(index + 1)
		}
	}

	if (value.length > maxChars) {
		value = value.substring(value.length - maxChars)
	}

	return value
}

export function roundNumber(num: number, decimalSpaces = 0): number {
	const multiplier = Math.pow(10, decimalSpaces)
	return Math.round((num + Number.EPSILON) * multiplier) / multiplier
}

export function padTime(num: number): string {
	return num < 10 ? "0" + num : num.toString()
}

export function get12HourFormat(hour: number) {
	return hour % 12 || 12
}

export function getAMorPM(hour: number) {
	return hour > 12 ? "PM" : "AM"
}

export function transformLinksToMarkdown(text: string): string {
	const startIndex = text.indexOf("<http")
	if (startIndex === -1) {
		return text
	}

	const endIndex = text.indexOf(">", startIndex)
	if (endIndex === -1) {
		return text
	}

	// Find last index of | before the >
	const pipeIndex = text.lastIndexOf("|", endIndex)
	if (pipeIndex === -1) {
		return text
	}

	// Change from <URL|TITLE> to [TITLE](URL)
	const url = text.substring(startIndex + 1, pipeIndex)
	const title = text.substring(pipeIndex + 1, endIndex)

	const newText = text.replace(
		text.substring(startIndex, endIndex + 1),
		`[${title}](${url})`,
	)

	return transformLinksToMarkdown(newText)
}
